import { baseCustomQuery } from '../baseQuery/baseCustomQuery';

const BASE_URL = process.env.https://fd.stg-pharmanavigator.senderrarx.com/backend-reports/;

const baseReportsQuery = baseCustomQuery(BASE_URL)

export default baseReportsQuery;
